import styled from 'styled-components';
import { CheckboxBase } from '../../../components/ToolkitV2/Inputs/CheckboxBase/CheckboxBase';
import type { ThemeTypes } from '../../../types/Theme.namespace';

const Container = styled.div`
  ${({ theme }) => theme.fontSize.M16};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.S4};
`;

const Text = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Icon = styled.span<{ gap?: ThemeTypes.Spacing }>`
  display: flex;
  align-items: center;
  margin-right: ${({ theme, gap }) =>
    gap ? theme.spacing[gap] : theme.spacing.S8};
`;

const TrailingIcon = styled(Icon)`
  margin-left: 0;
`;

const InfoIconContainer = styled.button`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin-left: auto;
  width: 48px;
  height: 48px;
`;

const Count = styled.div`
  ${({ theme }) => theme.fontSize.M16};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  flex: 0 1 auto;
`;

const NewIcon = styled.div`
  background-color: ${({ theme }) => theme.colors.OFFWHITE};
  border: 1px solid ${({ theme }) => theme.colors.GREY};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  margin-left: ${({ theme }) => theme.spacing.S8};
`;

const NewText = styled.span`
  ${({ theme }) => theme.fontSize.B12};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  padding: ${({ theme }) => theme.spacing.S2} ${({ theme }) => theme.spacing.S4};
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const Checkbox = styled(CheckboxBase)`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  padding: ${({ theme }) => theme.spacing.S12} 0;
  max-height: 48px;

  input[type='checkbox'] {
    opacity: 0;
    position: absolute;
    cursor: pointer;
  }

  &::before {
    content: '';
    flex: 0 0 auto;
    width: 24px;
    height: 24px;
    border-radius: ${({ theme }) => theme.borderRadius.default};
    background-color: ${({ theme }) => theme.colors.WHITE};
    border: 1px solid ${({ theme }) => theme.colors.GREY};
    margin-right: ${({ theme }) => theme.spacing.S8};
    transition: all 0.2s ease-out;
    position: relative;
  }

  &::after {
    content: '';
    position: absolute;
    margin-left: 8px;
    top: 50%;
    transform: translateY(-50%) rotate(45deg) scale(1);
    width: 6px;
    height: 12px;
    border: solid ${({ theme }) => theme.colors.WHITE};
    border-width: 0 2px 2px 0;
    transition: all 0.2s ease-out;
    opacity: 0;
  }

  &:has(input[type='checkbox']:checked)::before {
    background-color: ${({ theme }) => theme.colors.BLUE};
    border: 1px solid ${({ theme }) => theme.colors.BLUE};
  }

  &:has(input[type='checkbox']:checked)::after {
    opacity: 1;
  }

  &:has(input[type='checkbox']:focus-visible)::before {
    border-color: ${({ theme }) => theme.colors.BLUE};
  }
`;

export {
  Container,
  Text,
  Icon,
  TrailingIcon,
  InfoIconContainer,
  Count,
  NewIcon,
  NewText,
  Checkbox,
  Content,
};
